module.exports = __webpack_public_path__ + "img/04_full.0585f55e.jpg";